@switch (noText()) {
  @case (true) {
    <fin-text-on-image [imageData]="imageData()" [target]="cmsTarget()" [imageAspectRatio]="imageAspectRatio()" />
  }
  @case (false) {
    <fin-text-on-image
      [teaserTitle]="content().teaserTitle"
      [teaserText]="content().teaserText"
      [imageData]="imageData()"
      [target]="cmsTarget()"
      [imageAspectRatio]="imageAspectRatio()"
    />
  }
}
